import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import authReducer from './Slices/authSlice';
import uiReducer from './Slices/uiSlice';
import guestReducer from './Slices/guestSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    guest: guestReducer,
  },
  middleware: (getDefault) => getDefault({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
